import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CONTENT_STATUSES } from '../../../../utils/constants';


const STATUS_MAPPER = {
  [CONTENT_STATUSES.REJECTED]: CONTENT_STATUSES.REJECTED,

  [CONTENT_STATUSES.ACCEPTED]: CONTENT_STATUSES.ACCEPTED,
  [CONTENT_STATUSES.ACCEPTED_BUT]: CONTENT_STATUSES.ACCEPTED_BUT,

  [CONTENT_STATUSES.WAITING_CLIENT]: CONTENT_STATUSES.PENDING,
  [CONTENT_STATUSES.PENDING]: CONTENT_STATUSES.PENDING,

  [CONTENT_STATUSES.REVIEW]: CONTENT_STATUSES.NEEDS_REVIEW,
  [CONTENT_STATUSES.PENDING_INFLUENCER]: CONTENT_STATUSES.NEEDS_REVIEW,
  [CONTENT_STATUSES.WAITING_AM]: CONTENT_STATUSES.NEEDS_REVIEW,
  [CONTENT_STATUSES.NEEDS_REVIEW]: CONTENT_STATUSES.NEEDS_REVIEW,

  [CONTENT_STATUSES.NEEDS_MORE_INFORMATION]: CONTENT_STATUSES.NEEDS_MORE_INFORMATION,

  [CONTENT_STATUSES.NEEDS_SUBMISSION]: CONTENT_STATUSES.NEEDS_SUBMISSION
};

/**
 * @typedef BadgeStatusParams
 * @property {typeof CONTENT_STATUSES} status
 * @property {any} className
 *
 * @param {BadgeStatusParams} params
 * @returns
 */
const BadgeStatus = ({
  status,
  className,
  version = 2
}) => {
  const [variant, setVariant] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    switch (status) {
      case CONTENT_STATUSES.REVIEW:
      case CONTENT_STATUSES.NEEDS_REVIEW:
      case CONTENT_STATUSES.WAITING_AM:
      case CONTENT_STATUSES.PENDING_INFLUENCER:
      case CONTENT_STATUSES.PENDING:
      case CONTENT_STATUSES.WAITING_CLIENT:
        return setVariant(version === 3 ? 'primary' : 'secondary');
      case CONTENT_STATUSES.NEEDS_SUBMISSION:
        return setVariant('submission');
      case CONTENT_STATUSES.ACCEPTED_BUT:
        return setVariant('warning');
      case CONTENT_STATUSES.REJECTED:
      case CONTENT_STATUSES.NEEDS_MORE_INFORMATION:
        return setVariant('danger');
      case CONTENT_STATUSES.ACCEPTED:
        return setVariant(version === 3 ? 'success' : 'success');
    }
  }, [status]);

  if (STATUS_MAPPER[status])
    return (
      <Badge variant={variant} className={className}>
        {t(`common.content_approval.status.${STATUS_MAPPER[status]}`)}
      </Badge>
    );

  return null;
};


BadgeStatus.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.any,
  children: PropTypes.any,
  version: PropTypes.number,
};

BadgeStatus.defaultProps = {

};

export default React.memo(BadgeStatus);